import { render, staticRenderFns } from "./component.vue?vue&type=template&id=ab812c1e&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab812c1e')) {
      api.createRecord('ab812c1e', component.options)
    } else {
      api.reload('ab812c1e', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=ab812c1e&", function () {
      api.rerender('ab812c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-tencent-captcha/component.vue"
export default component.exports